// extracted by mini-css-extract-plugin
export default {"dlHierarchyBox":"src-js-containers-hierarchy-components-HierarchyBox---dlHierarchyBox---Bi3ks"};